var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53263 2.21208C8.86044 1.04031 7.13989 1.04031 6.4677 2.21208L1.56186 10.7639C0.902572 11.9132 1.74955 13.3333 3.09432 13.3333H12.906C14.2508 13.3333 15.0978 11.9132 14.4385 10.7639L9.53263 2.21208ZM8.00016 4.33325C7.63197 4.33325 7.3335 4.63173 7.3335 4.99992V8.99992C7.3335 9.36811 7.63197 9.66659 8.00016 9.66659C8.36835 9.66659 8.66683 9.36811 8.66683 8.99992V4.99992C8.66683 4.63173 8.36835 4.33325 8.00016 4.33325ZM8.00016 10.3333C7.63197 10.3333 7.3335 10.6317 7.3335 10.9999C7.3335 11.3681 7.63197 11.6666 8.00016 11.6666C8.36835 11.6666 8.66683 11.3681 8.66683 10.9999C8.66683 10.6317 8.36835 10.3333 8.00016 10.3333Z",
    fill: "#EF7C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.175865650119071cb067c09e85cab18f.svg";
export { ForwardRef as ReactComponent };